import { render } from "./BaseCard.vue?vue&type=template&id=151517ac&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=151517ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151517ac"]])

export default __exports__